class FeatureCollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.onBlockSelect = this.onBlockSelect.bind(this);
    this.syncActivePanelHeight = this.syncActivePanelHeight.bind(this);
  }

  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-feature-tab-button]'));
    this.panels = Array.from(this.querySelectorAll('[data-feature-tab-panel]'));

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.activate(button.dataset.tabId));
    });

    this.media = Array.from(this.querySelectorAll('.feature-collection-tabs__image, .feature-collection-tabs__video'));
    this.media.forEach((media) => {
      media.addEventListener('load', this.syncActivePanelHeight);
      media.addEventListener('loadedmetadata', this.syncActivePanelHeight);
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.syncActivePanelHeight);
      this.panels.forEach((panel) => {
        const banner = panel.querySelector('.feature-collection-tabs__banner');
        if (banner) this.resizeObserver.observe(banner);
      });
    }

    window.addEventListener('resize', this.syncActivePanelHeight);
    window.requestAnimationFrame(this.syncActivePanelHeight);
  }

  disconnectedCallback() {
    if (window.Shopify && window.Shopify.designMode) {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    window.removeEventListener('resize', this.syncActivePanelHeight);

    if (this.media) {
      this.media.forEach((media) => {
        media.removeEventListener('load', this.syncActivePanelHeight);
        media.removeEventListener('loadedmetadata', this.syncActivePanelHeight);
      });
    }
  }

  onBlockSelect(event) {
    const panel = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    if (!panel) return;

    this.activate(panel.dataset.tabId);
  }

  activate(tabId) {
    this.buttons.forEach((button) => {
      const isActive = button.dataset.tabId === tabId;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.tabId === tabId);
    });

    window.requestAnimationFrame(this.syncActivePanelHeight);
  }

  syncActivePanelHeight() {
    const activePanel = this.querySelector('[data-feature-tab-panel].is-active');
    if (!activePanel) return;

    const banner = activePanel.querySelector('.feature-collection-tabs__banner');
    const products = activePanel.querySelector('.feature-collection-tabs__products');
    if (!banner || !products) return;

    const bannerHeight = Math.round(banner.getBoundingClientRect().height);
    if (!bannerHeight) return;

    products.style.height = `${bannerHeight}px`;
    products.style.minHeight = `${bannerHeight}px`;
    products.style.maxHeight = `${bannerHeight}px`;
  }
}

if (!customElements.get('feature-collection-tabs')) {
  customElements.define('feature-collection-tabs', FeatureCollectionTabs);
}
